var ScrollToTop = /** @class */ (function () {
    function ScrollToTop() {
        this.errorPage = document.body.classList.contains('error404');
        this.toTopButton = document.querySelector('[data-to-top]');
        if (this.errorPage) {
            this.toTopButton.classList.add('hidden');
            return;
        }
        this.addEventListeners();
    }
    ScrollToTop.prototype.addEventListeners = function () {
        var _this = this;
        this.toTopButton.addEventListener('click', this.scrollToTop);
        // if scrolled more than 100px, show button
        window.addEventListener('scroll', function () {
            if (window.scrollY > 100) {
                _this.toTopButton.classList.remove('hidden');
            }
            else {
                _this.toTopButton.classList.add('hidden');
            }
        });
    };
    ScrollToTop.prototype.scrollToTop = function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return ScrollToTop;
}());
export default ScrollToTop;
